var _g, _g2, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLinkOverUi = function SvgLinkOverUi(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 103,
    viewBox: "0 0 120 103",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_140_9896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 74V26C20 23.7909 21.7909 22 24 22H96C98.2091 22 100 23.7909 100 26V74C100 76.2091 98.2091 78 96 78H24C21.7909 78 20 76.2091 20 74Z",
    fill: "url(#paint0_linear_140_9896)",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_140_9896)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_140_9896)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_140_9896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49 31.6827C49 31.3056 49.3056 31 49.6827 31H69.6507C70.0277 31 70.3333 31.3056 70.3333 31.6827V71.2773C70.3333 71.6544 70.0277 71.96 69.6507 71.96H49.6827C49.3056 71.96 49 71.6544 49 71.2773V31.6827Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_140_9896",
    x: 0,
    y: 6,
    width: 120,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_140_9896"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_140_9896",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_140_9896",
    x: 21,
    y: 9,
    width: 77.3333,
    height: 93.96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_140_9896"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_140_9896"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_140_9896",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_140_9896",
    x1: 100,
    y1: 56,
    x2: 2,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#075FF7",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80ADFA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_140_9896"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 31,
    width: 21.3333,
    height: 37.96,
    rx: 1.3,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_140_9896"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49 31.6827C49 31.3056 49.3056 31 49.6827 31H69.6507C70.0277 31 70.3333 31.3056 70.3333 31.6827V71.2773C70.3333 71.6544 70.0277 71.96 69.6507 71.96H49.6827C49.3056 71.96 49 71.6544 49 71.2773V31.6827Z",
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkOverUi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/link-over-ui.ff77d3e4.svg";
export { ForwardRef as ReactComponent };